import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { H3 } from '@repo/ui/components/Typography';

import { HideMobile } from 'styles/queries';

import Skeleton from './Skeleton';
import { Container, FlexRowCol } from './styles';
import { LayoutProps } from './types';

const skeletonRects = [{ width: '189px', height: '22px' }];

const ShortLayout: React.FC<LayoutProps> = ({
  isLoading,
  text,
  renderLinkButton,
  renderCopyButton,
}) => {
  return (
    <Container alignItems="center" direction="row">
      {isLoading ? <Skeleton rects={skeletonRects} /> : <H3>{text}</H3>}

      <FlexRowCol>
        {renderCopyButton()}
        <HideMobile>{renderLinkButton()}</HideMobile>
      </FlexRowCol>
    </Container>
  );
};

export default withEventScope(ShortLayout, { module: 'shortLayout' });
